import { ListBottom, ListMiddle, ListTop } from '@icon-park/react';
import React from 'react';
import { DynamicIcon } from "./DynamicIcon";
export var GlobalTask = function GlobalTask() {
  return /*#__PURE__*/React.createElement(DynamicIcon, {
    value: "primary",
    mapping: {
      primary: [/*#__PURE__*/React.createElement(ListTop, {
        key: "top"
      }), /*#__PURE__*/React.createElement(ListMiddle, {
        key: "middle"
      }), /*#__PURE__*/React.createElement(ListBottom, {
        key: "bottom"
      })]
    }
  });
};